import { IonPage } from "@ionic/react";
import { useParams } from "react-router-dom";

import { pronouns } from "../../domain/family";
import { useLinked } from "../../lib/linked";
import { useKaya } from "../../store/kayaStore";
import { setEatingProfile } from "../../store/toggles";
import { Questions } from "../FoodQuestions";
import { LinkedWaiting, familyPath } from "./linkedPage";

/**
 * "Fill her answers" (board FamilyView; ADR-046): the Plan my food questionnaire in a linked
 * person's name. The same screens over their state; Save stamps their eating block with the same
 * writer their phone uses and sends only that block, which the server merges as a second phone's
 * sync would be merged.
 */
export default function FamilyAnswers() {
  const { id } = useParams<{ id: string }>();
  const q = useLinked(id);
  const showToast = useKaya((s) => s.showToast);
  const back = familyPath(id);
  const l = q.linked;

  return (
    <IonPage>
      {l ? (
        <Questions
          subject={{
            S: l.S,
            name: l.name,
            pron: pronouns(l.S),
            back,
            save: async (answers) => {
              const overruled = await q.write(["eating"], (d) => {
                setEatingProfile(d, answers);
              });
              showToast(
                overruled.length
                  ? `${l.name} changed these on ${pronouns(l.S).their} phone since — ${pronouns(l.S).their} answers were kept`
                  : `Saved to ${l.name}’s account`
              );
            },
          }}
        />
      ) : (
        <LinkedWaiting q={q} title="Answers" back={{ to: back, label: "Back" }} />
      )}
    </IonPage>
  );
}
